import React from 'react'
import { connect } from 'react-redux'
import { Container, FilledButton, OutlinedButton } from '@jsluna/react'
import { withRouter } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import FormFieldValidation from 'components/FormFieldValidation'
import ManageContractors from 'components/ManageContractors'
import Breadcrumbs from 'components/Breadcrumbs'
import MessageDisplaySuccess from 'components/MessageDisplaySuccess'
import ErrorIcon from 'assets/images/ln-icon-error.svg'
import Loading from 'components/Loading'
import { toTitleCase } from '../../../utils/common'
import api from '../../../utils/api'
import { setCurrentEmployer } from '../../../store/current-employer/actions'

import DuplicateYCodeModal from '../../DuplicateYCodeModal'; 

class EmployerForm extends React.Component {
  constructor(props) {
    super(props)
   
    this.handleSaveClick = this.handleModalSaveClick.bind(this)
    this.handleModalCancel = this.handleModalCancel.bind(this)
    this.handleModalConfirm = this.handleModalConfirm.bind(this)
    this.duplicateModalText = this.duplicateModalText.bind(this)
    this.getHeader = this.getHeader.bind(this)

    this.handleTextChange = this.handleTextChange.bind(this)
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
   
    this.handleCancel = this.handleCancel.bind(this)
    this.handleWorkOrderChange = this.handleWorkOrderChange.bind(this)
    this.handleAddDomain = this.handleAddDomain.bind(this)
    this.handleDomainChange = this.handleDomainChange.bind(this)
    this.handleDomainBlurred = this.handleDomainBlurred.bind(this)

    let domainsProp = ['']

    if (this.props.employer.allowedDomains !== null) {
      if (this.props.employer.allowedDomains.includes(',')) {
        domainsProp = this.props.employer.allowedDomains.split(',')
        domainsProp.push('')
      }
      else {
        domainsProp = [this.props.employer.allowedDomains, '']
      }
    }

    this.state = {
      id: this.props.employer.id,
      name: this.props.employer.name || '',
      code: this.props.employer.code || '',
      emailAddress: this.props.employer.emailAddress || '',
      active: this.props.employer.active,
      hasMobileApp: this.props.employer.hasMobileApp,
      isMerchandiser: this.props.employer.isMerchandiser,
      errors: null,
      isNew: this.props.employer.id === 0,
      selectedTab: window.location.href.split('#')[1],
      hasWorkOrders: this.props.employer.id !== 0 ? this.props.employer.hasWorkOrders : null,
      domains: domainsProp,
      domainHasError: false,
      domainIsRepeated: false,
      domainIsValid: true,
      contractors: null,
      hasLoadedContractors: false,
      hasErrorLoadingContractors: false,
      refresh: false,
      showModal: false,   
      duplicatePayload: null,
      result:null
    }


  }

  componentWillMount() {
    this.props.setCurrentEmployer({ id: this.props.employer.id, name: this.props.employer.name })
    this.getData()
  }

  getData() {
    const apiCall = api.getEmployerAllContractors

    if (this.state.id > 0) {
      this.setState({ hasLoadedContractors: false })

      apiCall(this.state.id)
        .then((data) => {
          this.setState({ contractors: data, hasLoadedContractors: true })
        })
        .catch(() => {
          this.setState({ contractors: [], hasErrorLoadingContractors: true, hasLoadedContractors: true })
        })
    }
    else {
      this.setState({ contractors: [] })
    }
  }

  getHeader() {
    return (<div className="ln-o-grid">
      <div className="ln-o-grid__item ln-u-1/2@sm">
        <h3>{this.props.contractor.forename} {this.props.contractor.surname}</h3>
      </div>
      <div className="ln-o-grid__item ln-u-1/2@sm u-right-align-sm">
        <a href="" onClick={e => this.handleSaveClick(e, false)}><h6>Save</h6></a>
      </div>
    </div>)} //AkhileshLine

handleModalSaveClick(e) {
  this.handleModalSaveClick(e)
  if (!this.state.isBiometricDeletion) {
    this.handleCancel(e)
  }
}

handleModalCancel(e) {
  e.preventDefault()
  this.setState({ options: { deletionReasonTypeId: Constants.DeletionReasonTypes.None, isPreAction: true, inProgress: false } })
  this.setState({ isDeleteModalOpen: false, hasDeletionErrored: false })
}

handleModalConfirm(e) {
  e.preventDefault()
  const deletionEntity = {
    contractorId: this.props.contractor.id,
   
  }
  
}


  duplicateModalText(result) {
    if (result) {
      this.setState({ duplicateModalText:result.message })
    }
    }

    

  handleTextChange(e, key, doTrim, toUpperCase, toLowerCase, doTitleCase, callback) {
    const state = {}
    let value = e.target.value

    if (doTrim) {
      value = value.trim()
    }

    if (toUpperCase) {
      value = value.toUpperCase()
    }

    if (toLowerCase) {
      value = value.toLowerCase()
    }

    if (doTitleCase) {
      value = toTitleCase(value)
    }

    state[key] = value

    this.setState(state)
    this.props.setDirty()

    if (callback) {
      callback()
    }
  }

  handleCheckboxChange(e, key) {
    const state = {}

    state[key] = e.target.checked

    this.setState(state)
    this.props.setDirty()
  }

  handleWorkOrderChange(e) {
    this.setState({ hasWorkOrders: e.target.value === 'true' })
    this.props.setDirty()
  }

  checkDuplicateCodeSubmit(payload) {
    return api.checkDuplicateCode(payload.code)
        .then((response) => {
            console.log('Response:', response);
            if (response && response.message) {
                this.setState({ showModal: true, duplicatePayload: payload, result: response.message });
                console.log(payload);
                return 'return';
            } else {
                return 'continue';
            }
        })
        .catch((error) => {
            console.error('Submission error:', error);
            throw error; 

        });
}

callSubmit(payload){
 this.setState({ showModal: false });
  this.props.submit(payload).then(() => {
    this.setState({ refresh: true });
    window.scrollTo(0, 0);
  }).catch((error) => {
      console.error('Submission error:', error);
  });
}

  handleSubmit(e) {
    e.preventDefault()
    this.state.name = this.state.name.trim()
    this.state.code = this.state.code.trim()
    this.state.emailAddress = this.state.emailAddress.trim()
    const finalDomains = this.state.domains.filter(domain => domain !== '')
    const payload = {
      name: this.state.name,
      code: this.state.code,
      emailAddress: this.state.emailAddress,
      active: this.state.active,
      hasMobileApp: this.state.hasMobileApp,
      isMerchandiser: this.state.isMerchandiser,
      hasWorkOrders: this.state.hasWorkOrders,
      allowedDomains: finalDomains.length <= 1 ? finalDomains[0] : finalDomains.join(',')
    }

      this.checkDuplicateCodeSubmit(payload).then((response) => {
      if(response === 'continue'){
        this.props.submit(payload).then(() => {
          this.setState({ refresh: true });
          window.scrollTo(0, 0);
      }).catch((error) => {
          console.error('Submission error:', error);
      });
      }
    })

  }

  

  handleCancel(e) {
    e.preventDefault()
    this.props.cancel()
  }

  clearErrors(fieldName) {
    if (this.props.errors[fieldName]) {
      delete this.props.errors[fieldName]
    }
  }

  handleTabChange(tab,e) {
    e.preventDefault()
    this.state.selectedTab = tab
    this.forceUpdate()
    this.props.setDirty()
  }

  isChanged() {
    let isDomainChanged = true
    if (this.state.domains.filter(dom => dom !== '').length === 0 && this.props.employer.allowedDomains === null) {
      isDomainChanged = false
    }
    else if (this.state.domains.filter(dom => dom !== '').join(',') === this.props.employer.allowedDomains ) {
      isDomainChanged = false
    }
    return (this.state.name !== this.props.employer.name ||
      this.state.code !== this.props.employer.code ||
      this.state.emailAddress !== this.props.employer.emailAddress ||
      this.state.active !== this.props.employer.active ||
      this.state.hasWorkOrders !== this.props.employer.hasWorkOrders ||
      this.state.hasMobileApp !== this.props.employer.hasMobileApp ||
      this.state.isMerchandiser !== this.props.employer.isMerchandiser ||
      isDomainChanged)
  }

  isValidForm() {
    return (this.state.name !== '' &&
    this.state.code !== '' &&
    this.state.emailAddress !== '' &&
    this.state.hasWorkOrders !== null)
  }

  toggleSave() {
    return (this.isValidForm() &&
      this.isChanged())
  }

  handleAddDomain(e) {
    e.preventDefault()
    this.setState(prevState => ({
      domains: [...prevState.domains, '']
    }))
  }

  hideError(i) {
    document.getElementById('txtEmailDomain' + `${i}`).style.cssText = 'border-color: rgb(115, 115, 115);border-left-width: 1px;'
    for (let index = 0; index < this.state.domains.length; index++) {
      if (document.getElementById('txtEmailDomain' + `${index}`).getAttribute('disabled')) {
        document.getElementById('txtEmailDomain' + `${index}`).removeAttribute('disabled')
      }
    }
  }

  showError(i) {
    document.getElementById('txtEmailDomain' + `${i}`).style.cssText = 'border-color: #d70000;border-left-width: 4px;'
    for (let index = 0; index < this.state.domains.length; index++) {
      if (index !== i) {
        document.getElementById('txtEmailDomain' + `${index}`).setAttribute('disabled', true)
      }
    }
  }

  handleDomainChange(i, e) {
    const publicDomains = ['gmail.com', 'yahoo.com', 'yahoomail.com', 'hotmail.com', 'msn.com', 
    'rediffmail.com', 'ymail.com', 'googlemail.com', 'rocketmail.com', 'inbox.com', 'icloud.com']
    const regEx = /^([a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})$/

    const newDomains = this.state.domains
    const domainEntered = e.target.value.trim()
    newDomains[i] = domainEntered.length === 0 ? '' : '@' + domainEntered

    let count = 0
    newDomains.forEach(domain => {
      count += domain.slice(1) === domainEntered ? 1 : 0
    })

    const isPublic = publicDomains.some(publicDomain => { return domainEntered === publicDomain ? true : false })
    const isRepeated = count > 1 ? true : false

    this.setState({ domains: newDomains })
    this.props.setDirty()

    if (isPublic && domainEntered !== '') {
      this.setState({ domainHasError: true })
      this.showError(i)
      return
    }
    if (isRepeated && domainEntered !== '') {
      this.setState({ domainIsRepeated: true })
      this.showError(i)
      return
    }
    if (this.state.domainHasError === true || this.state.domainIsRepeated === true) {
      this.setState({ domainHasError: false, domainIsRepeated: false })
    }
    if (regEx.exec(domainEntered) && !this.state.domainIsValid) {
      this.setState({ domainIsValid: true })
    }
    if (this.state.domainHasError || this.state.domainIsRepeated || (!this.state.domainIsValid)) {
      this.hideError(i)
    }
  }

  handleDomainBlurred(i, e) {
    const domainEntered = this.state.domains[i]
    const regEx = /^@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})$/
    if (!regEx.exec(domainEntered) && domainEntered !== '') {
      this.setState({ domainIsValid: false })
      this.showError(i)
    }
    else if (!this.state.domainIsValid) {
      this.setState({ domainIsValid: true })
      this.hideError(i)
    }
  }
  
   
  submit(payload) {
    const isNew = this.state.employer.id === 0
    const apiCall = isNew ? api.addEmployer : api.updateEmployer
    return apiCall({ ...this.state.employer, ...payload })
      .then((response) => {
        if (response.ok) {
          return response.json().then((employer) => {
            if (isNew) {
              this.props.history.push(`/employers/${employer.id}#tab-colleagues`)
            } else {
              this.setState({ employer })
              this.setState({ errors: {} })
              this.setState({ isDirty: false })
              const message = 'Company details have been successfully updated'
              this.showSuccessMessage(message)
            }
          })
        } else {
          return response.json().then((errors) => {
            this.setState({ errors })
            //Console.log(response.statusText)
            return Promise.reject(errors)
          })
        }
      })
  }
  render() {
    if(this.state.refresh === true) {
      this.setState({refresh: false})
    }

    const showColleaguesTab =
      !this.state.isNew &&
      !this.isChanged() &&
      !this.props.errors.Name &&
      !this.props.errors.Code &&
      !this.props.errors.EmailAddress

    let domainErrorText = ''
    if(!this.state.domainIsValid) {
      domainErrorText = 'Please add a valid email domain'
    }
    else if(this.state.domainHasError) {
      domainErrorText = 'Please add a valid email domain that is not a public domain'
    }
    else if(this.state.domainIsRepeated) {
      domainErrorText = 'Please do not repeat the email domain'
    }

    const showDomainError = this.state.domainHasError || this.state.domainIsRepeated || (!this.state.domainIsValid)
    
    return (
      <div>
  { this.state.showModal &&
     
     <DuplicateYCodeModal
     modalAlertOpen={true}
   
    modalConfirm = { () => this.callSubmit(this.state.duplicatePayload)}
   
     modalCancel={() =>this.setState({showModal : false})}
     duplicateModalText={this.state.result}
   />
   }

      <div className='ln-c-main-content ln-o-main-content-width' id='main-content'>
        <Container soft>
          <MessageDisplaySuccess message={this.props.message} show={this.props.show} onDismiss={this.props.onDismiss} />
        </Container>
        
        <Container soft>
          <Breadcrumbs
            url={window.location.href}
            employerId={this.props.employer.id}
            employerName={this.props.employer.name}
            refresh={this.state.refresh}
          />
          <h3>{this.state.isNew ? 'Add a new company' : this.props.employer.name
            || 'Edit company'}
          </h3>
        </Container>
        
        <div className='ln-c-striped js-tabs'>
          <section className='ln-o-section'>
            <Container soft>
              <div className='ln-c-tabs'>
                <div className='ln-c-tabs__list-wrap'>
                  <div className='ln-c-tabs__list js-tab-list' role='tablist'>
                    <a
                      href='#tab-details' id='tab-details'
                      className={`ln-c-tabs__link js-tab-link ${this.state.selectedTab === 'tab-details' ?
                        'is-active' : ''}`}
                      aria-selected="true" role="tab"
                      aria-controls="tabpanel-details" onClick={(e) => this.handleTabChange('tab-details',e)}
                    >Details
                    </a>
                    {showColleaguesTab &&
                      <a
                        href='#tab-colleagues' id='tab-colleagues'
                        className={`ln-c-tabs__link js-tab-link ${this.state.selectedTab === 'tab-colleagues' ?
                          'is-active' : ''}`} aria-selected="false" role="tab"
                        aria-controls="tabpanel-employees"
                        onClick={(e) => this.handleTabChange('tab-colleagues',e)}
                      >Colleagues
                      </a>
                    }
                  </div>
                </div>
              </div>
              <article
                id='tabpanel-details'
                className={this.state.selectedTab !== 'tab-details' ?
                  'ln-u-hidden' : 'ln-c-card ln-c-card--soft js-tab-panel'}
                aria-hidden='false'
              >
                <div className='ln-o-article'>
                  <div
                    className={this.props.errors.Name ?
                      'ln-c-form-group ln-o-grid__item ln-o-grid--matrix ln-u-1/2@md ln-o-generic--div-without-padding has-error ln-o-form-error-message--inline-block' :
                      'ln-c-form-group ln-o-grid__item ln-u-1/2@md ln-o-generic--div-without-padding'}
                  >
                    <label htmlFor='txtCompanyName' className='ln-c-label'>
                      <span>Company name </span>
                      <span className='ln-c-label__info ln-u-visually-hidden'>Required</span>
                    </label>
                    <input
                      id='txtCompanyName'
                      type='text'
                      placeholder='Employer name'
                      className='ln-c-text-input'
                      value={this.state.name}
                      onChange={e => this.handleTextChange(e, 'name', false, false, false, true, this.clearErrors('Name'))} maxLength='60'
                    />
                    <FormFieldValidation errorMessages={this.props.errors.Name} htmlFor={'txtCompanyName'} />
                  </div>
                  <div
                    className={this.props.errors.Code ?
                      'ln-c-form-group ln-o-grid__item ln-o-grid--matrix ln-u-1/2@md has-error ln-o-form-error-message--inline-block' :
                      'ln-c-form-group ln-o-grid__item ln-u-1/2@md'}
                  >
                    <label htmlFor='txtCompanyCode' className='ln-c-label'>
                      <span>X|Y|Z-code</span>
                      <span className='ln-c-label__info ln-u-visually-hidden'>Required</span>
                    </label>
                    <input
                      id='txtCompanyCode'
                      type='text'
                      placeholder='X|Y|Z-code'
                      className='ln-c-text-input'
                      value={this.state.code}
                      onChange={e => this.handleTextChange(e, 'code', true, true, false, false, this.clearErrors('Code'))}
                      maxLength='5'
                    />
                    <FormFieldValidation errorMessages={this.props.errors.Code} htmlFor={'txtCompanyCode'} />
                  </div>
                  <div
                    className={this.props.errors.EmailAddress ?
                      'ln-c-form-group ln-o-grid__item ln-o-grid--matrix ln-u-1/2@md ln-o-generic--div-without-padding has-error ln-o-form-error-message--inline-block' :
                      'ln-c-form-group ln-o-grid__item ln-o-grid--matrix ln-u-1/2@md ln-o-generic--div-without-padding'}
                  >
                    <label htmlFor='txtEmailAddress' className='ln-c-label'>
                      <span>Email address </span>
                      <span className='ln-c-label__info ln-u-visually-hidden'>Required</span>
                    </label>
                    <input
                      id='txtEmailAddress'
                      type='text'
                      placeholder='Email address'
                      className='ln-c-text-input'
                      value={this.state.emailAddress}
                      onChange={e => this.handleTextChange(e, 'emailAddress', true, false, true, false, this.clearErrors('EmailAddress'))}
                      maxLength='240'
                    />
                    <FormFieldValidation errorMessages={this.props.errors.EmailAddress} htmlFor={'txtEmailAddress'} />
                  </div>
                  <div
                    className='ln-c-form-group ln-o-grid__item ln-u-1/2 ln-o-generic--div-inline-block'
                  >
                    <label htmlFor='txtActiveStatus' className='ln-c-label'>
                      <span>Active status </span>
                    </label><br />
                    <ul className='ln-o-bare-list'>
                      <li className='ln-o-bare-list__item'>
                        <div className='ln-c-form-option ln-c-form-option--checkbox'>
                          <input
                            className='ln-c-form-option__input'
                            id='chkActive'
                            type='checkbox'
                            defaultChecked={this.state.active}
                            onChange={e => this.handleCheckboxChange(e, 'active')}
                          />
                          <label
                            className='ln-c-form-option__label'
                            htmlFor='chkActive'
                          >Allow colleagues from this company to check in?</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className='ln-c-form-group ln-o-grid__item ln-o-grid--matrix ln-u-1/2@md ln-o-generic--div-without-padding'>
                    <Container onChange={e => this.handleWorkOrderChange(e)}>
                      <h3 className='ln-c-label' id='radioList'>Are work orders required?</h3>
                      <ul className='ln-o-matrix-list'>
                        <li className='ln-o-matrix-list__item'>
                          <div className='ln-c-form-option ln-c-form-option--full ln-c-form-option--radio'>
                            <input
                              className='ln-c-form-option__input'
                              id='radio1'
                              name='radio1'
                              type='radio'
                              value
                              defaultChecked={this.state.hasWorkOrders !== null && this.state.hasWorkOrders}
                            />
                            <label className='ln-c-form-option__label' htmlFor='radio1'>
                              Yes
                            </label>
                          </div>
                        </li>
                        <li className='ln-o-matrix-list__item'>
                          <div className='ln-c-form-option ln-c-form-option--full ln-c-form-option--radio'>
                            <input
                              className='ln-c-form-option__input'
                              id='radio2'
                              name='radio1'
                              type='radio'
                              value={false}
                              defaultChecked={this.state.hasWorkOrders !== null && !this.state.hasWorkOrders}
                            />
                            <label className='ln-c-form-option__label' htmlFor='radio2'>
                              No
                            </label>
                          </div>
                        </li>
                      </ul>
                    </Container>
                  </div>
                  <div
                    className='ln-c-form-group ln-o-grid__item ln-u-1/2 ln-o-generic--div-inline-block'
                  >
                    <label htmlFor='txtMobileAppStatus' className='ln-c-label'>
                      <span>Mobile app use </span>
                    </label><br />
                    <ul className='ln-o-bare-list'>
                      <li className='ln-o-bare-list__item'>
                        <div className='ln-c-form-option ln-c-form-option--checkbox'>
                          <input
                            className='ln-c-form-option__input'
                            id='chkMobileApp'
                            type='checkbox'
                            defaultChecked={this.state.hasMobileApp}
                            onChange={e => this.handleCheckboxChange(e, 'hasMobileApp')}
                          />
                          <label
                            className='ln-c-form-option__label'
                            htmlFor='chkMobileApp'
                          >Allow use of mobile app?</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div
                    className='ln-c-form-group ln-o-grid__item ln-o-grid--matrix ln-u-1/2@md ln-o-generic--div-without-padding'
                  >
                    <label htmlFor='txtMerchandiserStatus' className='ln-c-label'>
                      <span>Is this a merchandising company? </span>
                    </label><br />
                    <ul className='ln-o-bare-list'>
                      <li className='ln-o-bare-list__item'>
                        <div className='ln-c-form-option ln-c-form-option--checkbox'>
                          <input
                            className='ln-c-form-option__input'
                            id='chkMerchandiser'
                            type='checkbox'
                            defaultChecked={this.state.isMerchandiser}
                            onChange={e => this.handleCheckboxChange(e, 'isMerchandiser')}
                          />
                          <label
                            className='ln-c-form-option__label'
                            htmlFor='chkMerchandiser'
                          >Allow colleagues from this company to sign in as a merchandiser</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div
                    className='ln-c-form-group ln-o-grid__item ln-u-1/2 ln-o-generic--div-inline-block'
                  >
                    <label htmlFor='txtEmailDomain' className='ln-c-label'>
                      <span>Email address domains (optional)</span>
                    </label>
                    <div className='ln-o-generic--margin-top-and-bottom'>
                      <div>Add email address domains to allow for colleagues to register automatically</div>
                      <div><b>Please don&#39;t add public domains, only add domains owned by the company</b></div>
                    </div>
                    {this.state.domains.map((element, index) => (
                      <div>
                        <div style={{ display: 'flex', alignItems: 'baseline' }} key={index}>
                          <p style={{ marginRight: '10px' }}>@</p>
                          <input
                            id={'txtEmailDomain' + `${index}`}
                            type='text'
                            placeholder='companyname.co.uk'
                            value={element.slice(1)}
                            onChange={e => this.handleDomainChange(index, e)}
                            onBlur={e => this.handleDomainBlurred(index, e)}
                            className='ln-c-text-input'
                            maxLength='240'
                            disabled={false}
                          />
                        </div>
                      </div>
                    ))}
                    {showDomainError &&
                    <div className="ln-o-flag" style={{ marginTop: '-0.5rem'}}>
                      <div className="ln-o-flag__component">
                        <svg
                          className="ln-icon-error formErrorIcon" 
                          role="presentation"
                          viewBox="0 0 50 50"
                        >
                          <use xlinkHref={`#${ErrorIcon.id}`} />
                        </svg>
                      </div>
                      <div className="ln-o-flag__body" style={{ fontWeight: 'bold' }}>{domainErrorText}</div>
                    </div>
                    }
                    <button
                      className='u-button-underline orange'
                      onClick={this.handleAddDomain}
                      disabled={showDomainError}
                      style={{ marginLeft: '0rem' }}
                    >
                      Add another domain
                    </button>
                  </div>
                  <div className='ln-o-grid ln-o-grid--bottom ln-o-grid--matrix'>
                    <div className='ln-o-grid__item ln-u-1/6@md ln-u-1/3@xs ln-u-1/6@sm'>
                      <OutlinedButton
                        color={'#8e8e8e'}
                        className='ln-c-button ln-c-button--full ln-c-button--secondary'
                        role='button' onClick={this.handleCancel}
                      >Cancel</OutlinedButton>
                    </div>
                    <div className='ln-o-grid__item ln-u-1/6@md ln-u-1/3@xs ln-u-1/6@sm'>
                      <FilledButton
                        className='ln-c-button ln-c-button--full ln-c-button--primary'
                        onClick={this.handleSubmit}
                        disabled={!this.toggleSave() || showDomainError}
                      >Save</FilledButton>
                    </div>
                  </div>
                </div>
              </article>
              <article
                id='tabpanel-employees'
                className={this.state.selectedTab !== 'tab-colleagues' ?
                  'ln-u-hidden' : 'ln-c-card ln-c-card--soft js-tab-panel'} role='tabpanel' aria-hidden='true'
                style={({ padding: 0 })}
              >
                { !this.state.hasLoadedContractors && 
                  <Container soft className="ln-u-text-align-center">
                    <div className="ln-o-grid">
                      <div className="ln-o-grid__item ln-u-1/4">
                        <Loading title="Loading colleagues" />
                      </div>
                    </div>
                  </Container>
                }
                { this.state.hasLoadedContractors && 
                  <div className="ln-o-article ln-o-generic--tab-panel-without-padding">
                    <ManageContractors 
                      employerId={this.state.id} 
                      isReadOnly={!this.state.id || this.state.id === 0} 
                      contractors={this.state.contractors}
                      hasErrorLoadingContractors={this.state.hasErrorLoadingContractors}
                    />
                  </div>
                }
              </article>
            </Container>
          </section>
        </div>
      </div>
      </div>
    )
  }
}

EmployerForm.propTypes = {
  employer: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    code: PropTypes.string,
    emailAddress: PropTypes.string,
    active: PropTypes.bool,
    hasMobileApp: PropTypes.bool,
    isMerchandiser: PropTypes.bool,
    hasWorkOrders: PropTypes.bool,
    allowedDomains: PropTypes.oneOfType([
      PropTypes.string,
      null
    ])
  }).isRequired,
  message: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    Name: PropTypes.arrayOf(PropTypes.string),
    Code: PropTypes.arrayOf(PropTypes.string),
    EmailAddress: PropTypes.arrayOf(PropTypes.string)
  }),
  setDirty: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  setCurrentEmployer: PropTypes.func.isRequired
}

EmployerForm.defaultProps = {
  errors: null
}

const mapDispatchToProps = dispatch => ({
  setCurrentEmployer: (emp) => {
    dispatch(setCurrentEmployer(emp))
  }
})

export default connect(null, mapDispatchToProps)(withRouter(EmployerForm))



// WEBPACK FOOTER //
// ./src/components/Employer/EmployerForm/index.jsx